import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaStore, FaHistory } from "react-icons/fa";

const NavigationButtons = ({ tipo }) => {
  return (
    <div className="ml-auto   justify-end flex space-x-2 md:space-x-6">
      <Link
        to={tipo === "mayorista" ? "/venta/minorista" : "/venta/mayorista"}
          className="flex items-center gap-1 md:gap-2 bg-gradient-to-r  text-black py-2 md:py-2 px-2 }"
      >
        {tipo === "mayorista" ? (
          <>
            <FaStore className="text-sm md:text-lg" />
            <span className="hidden md:inline">Venta por Menor</span>
            <span className="md:hidden">Menor</span>
          </>
        ) : (
          <>
            <FaShoppingCart className="text-sm md:text-lg" />
            <span className="hidden md:inline">Venta Mayorista</span>
            <span className="md:hidden">Mayor</span>
          </>
        )}
      </Link>

      <Link
        to="/ventas"
        className="flex items-center gap-1 md:gap-3 text-gray-700 hover:text-indigo-500 transition-colors duration-200 text-xs md:text-base"
      >
        <FaHistory className="text-sm md:text-lg" />
        <span className="hidden md:inline">Historial</span>
      </Link>
    </div>
  );
};

export default NavigationButtons;
